import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueCookies from 'vue-cookies'
import store from './store'

Vue.use(VueCookies)
Vue.$cookies.config('300d')

Vue.config.productionTip = false

new Vue({
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
